<div class="card-holder">
  <div class="card-header text-center">
    <div class="w-full flex justify-center">
      <div class="initials flex justify-center items-center">
<!--        {{ nameInitials }}-->
        <svg width="29" height="26" viewBox="0 0 29 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 23.3333V0H12.6663V5.33333H25.692V16.205H23.6923V7.33333H12.6663V10.6667H15.5897V12.6667H12.6663V16H15.5897V18H12.6663V21.3333H18.5127V23.3333H0ZM1.99967 21.3333H5.33333V18H1.99967V21.3333ZM1.99967 16H5.33333V12.6667H1.99967V16ZM1.99967 10.6667H5.33333V7.33333H1.99967V10.6667ZM1.99967 5.33333H5.33333V2H1.99967V5.33333ZM7.333 21.3333H10.6667V18H7.333V21.3333ZM7.333 16H10.6667V12.6667H7.333V16ZM7.333 10.6667H10.6667V7.33333H7.333V10.6667ZM7.333 5.33333H10.6667V2H7.333V5.33333ZM23.6923 26V23.3333H21.0257V21.3333H23.6923V18.6667H25.692V21.3333H28.3587V23.3333H25.692V26H23.6923ZM18.5127 12.6667V10.6667H20.5127V12.6667H18.5127ZM18.5127 18V16H20.5127V18H18.5127Z" fill="white"/>
        </svg>

      </div>
    </div>
    <div class="company-name txt-ellipsis">
      {{
        company?.orgName || ("common-keywords.company-name" | translate)
          | titlecase
      }}
    </div>
    <div class="company-size">
      {{ "common-keywords.company-size" | translate }} {{ size || "-" }}
    </div>
  </div>
  <div class="card-footer">
    <div class="list-item">
      <span>{{ "common-keywords.first-name" | translate }}</span>
      <span class="txt-ellipsis">{{ company?.firstName || "-" }}</span>
    </div>
    <div class="list-item">
      <span>{{ "common-keywords.last-name" | translate }}</span>
      <span class="txt-ellipsis">{{ company?.lastName || "-" }}</span>
    </div>
    <div class="list-item">
      <span>{{ "common-keywords.country" | translate }}</span>
      <span class="txt-ellipsis">{{ country || "-" }}</span>
    </div>
    <div class="list-item">
      <span>{{ "common-keywords.contact-number" | translate }}</span>
      <span class="txt-ellipsis">{{ company?.phoneNumber || "-" }}</span>
    </div>
    <div class="list-item">
      <span>{{ "common-keywords.industry" | translate }}</span>
      <span class="txt-ellipsis">{{ company?.industry || "-" }}</span>
    </div>
  </div>
</div>
